import equal from 'fast-deep-equal';
import get from 'lodash/get';
import { FormPropsType } from 'src/components/UI/types';

type BaseProps = {
  formProps: FormPropsType;
};

/**
 * be carefull using this
 * the custom memo function which compares props ignoring formState of formProps
 */
export const uiMemoFormPropsCompareFn = (prevProps: BaseProps, nextProps: BaseProps): boolean => {
  /**
   * as formState can be different at every form change
   * compare equality of props without formState
   */
  const {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    formProps: { formState: noNeedPrev, ...formPropsPrev },
    ...restPrev
  } = prevProps;
  const {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    formProps: { formState: noNeedNext, ...formPropsNext },
    ...restNext
  } = nextProps;

  return equal({ formProps: { ...formPropsPrev }, ...restPrev }, { formProps: { ...formPropsNext }, ...restNext });
};

type PropsWithName = BaseProps & { name: string; required?: boolean; validationName?: string };

export const formPropsErrorsGlobalState: Record<string, boolean> = {};

/**
 * the idea is to check whether input has or had error (using simple global variable),
 *    check if error changed,
 *    and decide if it should have render or not
 * */
export const uiMemoFormPropsInputCompareFn = (prevProps: PropsWithName, nextProps: PropsWithName): boolean => {
  const { errors } = nextProps.formProps.formState;

  const hasError = !!get(errors, nextProps.name, false);
  const hasErrorValidation = !!nextProps?.validationName && !!get(errors, nextProps.validationName, false);

  const validationErrorName = `${nextProps.name}_${nextProps.validationName}`;

  if (nextProps?.validationName && formPropsErrorsGlobalState[validationErrorName] !== hasErrorValidation) {
    /** if state error was undefined, not to set it as false */
    if (!(formPropsErrorsGlobalState[validationErrorName] === undefined && !hasErrorValidation)) {
      formPropsErrorsGlobalState[validationErrorName] = hasErrorValidation;
      return false; // render anyway
    }
  }

  if (formPropsErrorsGlobalState[nextProps.name] !== hasError) {
    /** if state error was undefined, not to set it as false */
    if (!(formPropsErrorsGlobalState[nextProps.name] === undefined && !hasError)) {
      formPropsErrorsGlobalState[nextProps.name] = hasError;
      return false; // render anyway
    }
  }

  return uiMemoFormPropsCompareFn(prevProps, nextProps);

  // use this if any problems appear
  // return nextProps.required || get(nextProps.formProps.formState.errors, nextProps.name, false)
  //   ? false
  //   : equal(prevProps, nextProps);
};
